import { AcknowledgedByChannels } from './textBuilders/AcknowledgedBy'
import { DeleteConsequence } from './textBuilders/DeleteConsequence'
import { FalsePositiveByChannels, ResolvedByChannels } from './textBuilders/StatusBy'
import { TriggerConditionExpression } from './textBuilders/TriggerConditionExpression'
import { TriggerOn } from './textBuilders/TriggerOn'

export default {
    values: {
        TriggerConditionExpression,
        activeRuleDeleteMsg: 'Active rules can not be deleted. Inactivate the rule in order to be able to delete it.',
        DeleteConsequence,
        deletePlaceholder: 'Type “DELETE” to confirm',
        '%n seconds': [
            [0, 1, 'second'],
            [2, null, 'seconds']
        ],
        '%n minutes': [
            [0, 1, 'minute'],
            [2, null, 'minutes']
        ],
        '%n hours': [
            [0, 1, 'hour'],
            [2, null, 'hours']
        ],
        AcknowledgedByChannels,
        ResolvedByChannels,
        FalsePositiveByChannels,
        'channels-conditional-min': 'min',
        TriggerOn
    }
}
